module.exports = "<div id=\"stripe-connect-success\" class=\"section-full-height\">\n  <div class=\"error\" ng-if=\"error\">\n    <div class=\"alert alert-danger\">\n      {{ error }}\n    </div>\n    <br>\n    <br>\n    <a href=\"#\" ui-sref=\"login\" class=\"btn btn-primary\">\n      Back to login\n    </a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/stripeConnectSuccess/stripeConnectSuccess.html
// module id = 550
// module chunks = 1